import { FormElementWrapperWithAccountExists } from 'components/FormElements';
import { useTrialsContext } from 'contexts/TrialsContextProvider';

import TrialFormField from './TrialFormField';

const MobileField = ({
  placeholder = 'Mobile Number',
  trackingEventName = 'profile',
  ...props
}) => {
  const {
    accountInfoFieldProps = {},
    checkPhoneNumberExists,
    phone,
    phoneExists,
    setPhone,
  } = useTrialsContext() || {};

  const formatAndSetPhone = (value) => {
    const strippedPhone = value?.replace(/[^.\d]/g, '');
    setPhone(strippedPhone);
  };

  const handlePhoneBlur = async () => {
    if (checkPhoneNumberExists) {
      await checkPhoneNumberExists(phone);
    }
  };

  return (
    <FormElementWrapperWithAccountExists
      fieldExists={phoneExists}
      fieldName="phone"
    >
      <TrialFormField
        customOnBlur={handlePhoneBlur}
        errors={accountInfoFieldProps.errors}
        fieldName="phone"
        id="trial-mobile-phone"
        isUserProperty
        mask="phone"
        placeholder={placeholder}
        setErrors={accountInfoFieldProps.setErrors}
        setFieldValue={formatAndSetPhone}
        trackError
        trackingEventName={trackingEventName}
        type="tel"
        value={phone}
        {...props}
      />
    </FormElementWrapperWithAccountExists>
  );
};

export default MobileField;
